import { useApolloClient } from '@apollo/client';

export function useSafeApolloClient() {
  try {
    return useApolloClient();
  } catch {
    return null;
  }
}
